<template>
  <v-card class="mb-3">
    <v-card-title class="title"
      >Key Mapper - Student
      <v-spacer></v-spacer>
      <!-- <v-checkbox
        style="display: unset !important"
        v-model="secondary"
        :label="secondary ? `Secondary` : `Primary`"
        required
      ></v-checkbox> -->
    </v-card-title>
    <span class="grey--text pl-3">
      Student Id and Class is required to add students.
    </span>
    <v-layout
      class="d-flex pa-3"
      style="justify-content: space-between; flex-wrap: wrap;"
    >
      <v-flex sm6 md3 lg2 v-for="key in mappingKeys" :key="key">
        <v-autocomplete
          v-model="keymap[key]"
          :items="remainList()"
          outlined
          dense
          :label="key.toUpperCase()"
        ></v-autocomplete>
        <!-- <v-select
          :search-input.sync="keymapsearch[key]"
          v-model="keymap[key]"
          :items="remainList()"
          :label="key.toUpperCase()"
          autocomplete
          required
        ></v-select> -->
      </v-flex>
    </v-layout>

    <v-layout class="pa-3" v-if="newclasses.length > 0">
      <v-flex>
        <h5>Available Class List</h5>
        <v-data-table
          :search="search"
          :items="availableClasses"
          class="elevation-1"
          item-key="key"
        >
          <template slot="items" slot-scope="props">
            <td>{{ props.item.text }}</td>
            <td align="right">
              <v-btn
                color="clear"
                small
                icon
                v-on:click.stop="handleDelete(props.index, props.item)"
                ><v-icon>check</v-icon></v-btn
              >
            </td>
          </template>
        </v-data-table>
      </v-flex>
      <div style="width: 10px;"></div>
      <v-flex>
        <div>
          <h5>Additional Class List</h5>
          <v-data-table
            :items="newclasses"
            :hideActions="true"
            class="elevation-1"
            item-key="key"
          >
            <template slot="items" slot-scope="props">
              <td>{{ props.item.text }}</td>
              <td align="right">
                <v-btn
                  color="clear"
                  small
                  icon
                  v-on:click.stop="handleDelete(props.index, props.item)"
                  ><v-icon>check</v-icon></v-btn
                >
              </td>
            </template>
          </v-data-table>
        </div>
        <v-btn
          v-if="newclasses.length > 0"
          class="elevation-0"
          style="float: right;"
          color="primary"
          @click="createClassType"
        >
          Add Additional Classes
        </v-btn>
      </v-flex>
    </v-layout>
    <v-flex style="text-align: right" class="pa-3">
      <v-btn
        class="elevation-0"
        color="primary"
        @click="
          $emit(
            'process',
            keymap,
            requiredKeys,
            secondary ? 'secondary' : 'primary',
            availableClasses
          )
        "
      >
        Process
      </v-btn>
    </v-flex>
  </v-card>
</template>

<script>
import APIClassType from "@/mixins/APIClassType";
export default {
  mixins: [APIClassType],
  props: {
    bulk: Object
  },
  data() {
    return {
      searchInput: "",
      classKeyField: "HOME_GROUP",
      secondary: false,
      search: "",
      keymapsearch: {},
      keymapPrimary: {
        student_id: "",
        first_name: "",
        last_name: "",
        class: "",
        dob: "",
        email: "",
        school_year: "",
        status: 1
      },
      keymapSecondary: {
        student_id: "",
        first_name: "",
        last_name: "",
        class: "",
        dob: "",
        email: "",
        school_year: "",
        contact: "",
        parent_a_fname: "",
        parent_a_lname: "",
        parent_a_mobile: "",
        parent_b_fname: "",
        parent_b_lname: "",
        parent_b_mobile: "",
        status: 1,
        is_secondry: true
      },
      requiredKeys: ["class"],
      savedClasses: [],
      availableClasses: [],
      newclasses: []
    };
  },
  watch: {
    keymap: {
      handler: function(val) {
        if (val["class"]) {
          this.classKeyField = val["class"];
          this.analyzeForNewClasses();
        }
      },
      deep: true
    }
  },
  computed: {
    bulkDefinedClasses: function() {
      if (!this.bulk || !this.bulk.data) {
        return [];
      }
      let list = this.bulk.data.map(obj => {
        return obj[this.classKeyField] || "";
      });
      if (list.length == 0) {
        return [];
      }
      return Array.from(new Set(list));
    },
    keymap: function() {
      return this.secondary ? this.keymapSecondary : this.keymapPrimary;
    },
    mappingKeys: function() {
      let ob = this.secondary ? this.keymapSecondary : this.keymapPrimary;
      return Object.keys(ob).filter(obj => {
        return !["status", "is_secondry"].includes(obj);
      });
    }
  },
  created() {
    this.loadAvailableClassList();
  },
  methods: {
    remainList: function() {
      return this.bulk.headers; //.sort((a, b) => a.localeCompare(b));
    },
    analyzeForNewClasses: function() {
      let fllist = this.savedClasses
        .map(obj => {
          return obj.class_type;
        })
        .join(",");
      let filteredlist = this.bulkDefinedClasses.filter(obj => {
        if (fllist.includes(obj)) {
          return false;
        }
        return true;
      });
      this.newclasses = filteredlist.map(obj => {
        return { key: obj, value: obj, text: obj };
      });
      let list = this.savedClasses.map(obj => {
        return {
          key: obj._id,
          value: obj._id,
          text: obj.class_type,
          class_type: obj.class_type
        };
      });
      this.availableClasses = list;
    },
    createClassType: async function() {
      await this.postClassTypeBulk(this.bulkDefinedClasses);
      await this.loadAvailableClassList();
      this.$emit(
        "process",
        this.keymap,
        this.requiredKeys,
        this.secondary ? "secondary" : "primary",
        this.availableClasses
      );
    },
    loadAvailableClassList: async function() {
      try {
        this.savedClasses = await this.getClassTypes();
        let list = this.savedClasses.map(obj => {
          return {
            key: obj._id,
            value: obj._id,
            text: obj.class_type,
            class_type: obj.class_type
          };
        });
        this.availableClasses = list;
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>
